<template>
  <div class="app">
    <v-app-bar dark dense color="bluePcm">
      <ClientNameAppbar />

      <v-spacer />

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="orangePcm" v-bind="attrs" v-on="on" @click="logoff">
            <v-icon>mdi-power-standby</v-icon>
          </v-btn>
        </template>
        <span>Deslogar</span>
      </v-tooltip>
    </v-app-bar>
  </div>
</template>

<script>
import ClientNameAppbar from '@/componentes/ClientNameAppbar'
import { logoutMethod } from '@/utils/commomMethods/logoutMethod'

export default {
  components: { ClientNameAppbar },

  methods: {
    ...logoutMethod,
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
